export default __webpack_public_path__ + "assets/img/logo.9be6106.svg";